import React from 'react';
import ReactDOM from "react-dom";
import './index.css';
import App from './App';
import Investors from './components/Investors';
import Community from './components/Community';
import Startups from './components/Startups';
import Advisors from './components/Advisors';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />
  },
  {
    path: "/investors",
    element: <Investors />
  },
  {
    path: "/community",
    element: <Community />
  },
  {
    path: "/startups",
    element: <Startups />
  },
  {
    path: "/advisors",
    element: <Advisors />
  },
  {
    path: "/aboutus",
    element: <AboutUs />
  },
  {
    path: "/contact",
    element: <Contact />
  },
]);

ReactDOM.render(
  <RouterProvider router={router} />,
  document.getElementById("root")
);